import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-info.types';
import * as constants from './meeting-info.constants';

export const storeMeetingInfo = generateStoreResourceAction<types.IMeetingInfo>(constants.STORE_MEETING_INFO);
export const clearMeetingInfo = generateClearResourceAction(constants.CLEAR_MEETING_INFO);
